import { render, staticRenderFns } from "./BatchStatisticsResult.vue?vue&type=template&id=e626ac44&scoped=true"
import script from "./BatchStatisticsResult.vue?vue&type=script&lang=js"
export * from "./BatchStatisticsResult.vue?vue&type=script&lang=js"
import style0 from "./BatchStatisticsResult.vue?vue&type=style&index=0&id=e626ac44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e626ac44",
  null
  
)

export default component.exports